import { render } from "./NewMasterFileUpload.vue?vue&type=template&id=1cbb160e"
import script from "./NewMasterFileUpload.vue?vue&type=script&lang=js"
export * from "./NewMasterFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__